<template>

  <!-- First section for editing the line -->
  <tr v-if='editLine || editMode'>
    <td :class='fontColor + "--text"'>
      {{ line.added_by ? line.added_by_obj.first_name : "" }}
    </td>
     <td>
      <v-form v-model='isFormValid'>
        <v-text-field
          ref='description'
          :id='"description"+line.id'
          dense
          hide-details
          class='body-2'
          v-model='lineCopy.task_completed'
          :rules='[rules.required]'
        ></v-text-field>
      </v-form>
    </td>
    <td>
      <v-form v-model='isFormValid'>
        <v-text-field
          ref='num_mins'
          :id='"num_mins"+line.id'
          dense
          hide-details
          reverse
          @focus='focusNumMins'
          :rules='[rules.posInt]'
          class='body-2'
          v-model='lineCopy.num_mins'
          @update:error='displayNumMinsError'
        ></v-text-field>
      </v-form>
    </td>
    <td>
      <v-form v-model='isFormValid'>
        <v-text-field
          ref='num_workers'
          :id='"num_workers" + line.id'
          dense
          single-line
          reverse
          hide-details
          class='body-2'
          @focus='focusNumWorkers'
          :rules='[rules.posInt]'
          v-model='lineCopy.num_workers'
          @update:error='displayNumWorkersError'
        ></v-text-field>
      </v-form>
    </td>
    <td>
      <v-autocomplete
        id='type'
        ref='type'
        dense
        single-line
        hide-details
        :items='labour'
        :item-text='getPrice'
        v-model='selected'
        return-object
        @change='updateType'
        class='body-2'
      >
      </v-autocomplete>
    </td>
    <td>
      <v-checkbox class='ml-2 mt-0 mb-n4' dense v-model='lineCopy.is_warranty'></v-checkbox>
    </td>
    <td class='text-right' :class='fontColor + "--text"'>
      {{ line.is_warranty ? 0 : (line.labour_type_obj.service_price * (line.num_mins * line.num_workers / 60) ) | dec }}
    </td>
    <td valign='middle' align='middle'>
      <v-btn
        x-small
        :disabled='savingLine'
        color='error'
        dark
        class='mr-1'
        @click='cancel'
      >
        <v-icon small>mdi-close</v-icon>
      </v-btn>
      <template v-if='isFormValid && lineCopy.labour_type_obj.service_price'>
        <v-btn
          x-small
          :loading='savingLine'
          color='success'
          @click='saveLine'
        >
        <template v-slot:loader>
          <v-progress-circular color='white' indeterminate :size='14' :width='1'></v-progress-circular>
        </template>
          <v-icon small>mdi-check</v-icon>
        </v-btn>
      </template>
      <template v-else>
        <v-tooltip top>
          <template v-slot:activator='{ on }'>
            <v-btn
              v-on='on'
              x-small
              color='error'
            >
              <v-icon small>mdi-alert-circle</v-icon>
            </v-btn>
          </template>
          <span>{{ lineCopy.labour_type_obj.service_price ? 'Details are missing' : 'Please select a rate' }}</span>
        </v-tooltip>
      </template>
    </td>
  </tr>

  <!-- This section just for displaying the line -->
  <tr v-else>
    <td :class='fontColor + "--text"'>
      {{ line.added_by ? line.added_by_obj.first_name : "" }}
    </td>
    <td :class='fontColor + "--text"'>
      {{ line.task_completed }}
    </td>
    <td class='text-right' :class='fontColor + "--text"'>
      {{ line.num_mins }}
    </td>
    <td class='text-right' :class='fontColor + "--text"'>
      {{ line.num_workers }}
    </td>
    <td class='text-right' :class='fontColor + "--text"'>
      {{ line.labour_type_obj.service_price | dec }}
    </td>
     <td class='text-right' :class='fontColor + "--text"'>
      {{ line.is_warranty | trueFalse }}
    </td>
    <td class='text-right' :class='fontColor + "--text"'>
      {{ line.is_warranty ? 0 : (line.labour_type_obj.service_price * (line.num_mins * line.num_workers / 60) ) | dec }}
    </td>
    <td class='text-right'>
      <wc-line-actions
        v-if='!disableEdit'
        hideSortUp
        hideSortDown
        @edit='setupEdit'
        @deleteLine="$emit('deleteLine', line)"
      >
      </wc-line-actions>
    </td>
  </tr>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'

export default {
  name: 'work-order-processing-labour-line',
  mixins: [formRules],
  props: {
    line: {
      required: true
    },
    editMode: {
      required: false,
      type: Boolean,
      default: false
    },
    labour: {
      required: true,
      type: Array,
    },
    fontColor: {
      required: false,
      type: String,
      default: 'grey'
    },
    disableEdit: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    editLine: false,
    lineCopy: { labour_type_obj: {} },
    savingLine: false,
    isFormValid: false,
    inputClass: 'body-2',
    selected: ''
  }),
  computed: {

  },
  mounted () {
    if (this.editMode) {
      this.setupEdit()
    }
  },
  methods: {
    setupEdit () {
      this.lineCopy = _.cloneDeep(this.line)
      this.selected = _.find(this.labour, i => i.id === this.lineCopy.labour_type )
      this.editLine = true
    },
    saveLine () {
      this.savingLine = true
      this.$emit('save', this.lineCopy)
      this.editLine = false
      this.savingLine = false
    },
    updateType () {
      this.isFormValid = true
      this.lineCopy.labour_type_obj.service_price = this.selected.service_price
      this.lineCopy.labour_type = this.selected.id
      this.$refs.type.blur()
      this.focusNumMins()
    },
    getPrice (item) {
      return this.$options.filters.decMoney(item.service_price) + "/hr - " + item.description 
    },
    focusNumWorkers() {
      setTimeout(() => {
        document.getElementById('num_workers'+this.line.id).select()
      }, 50)
    },
    focusNumMins() {
      setTimeout(() => {
        document.getElementById('num_mins'+this.line.id).select()
      }, 50)
    },
    cancel () {
      if (this.editMode) {
        this.$emit('cancelCreate')
      } else {
        this.editLine = false
        this.displayNumMinsError (false)
      }
    },
    displayNumMinsError (val) {
      let message
      if (val) {
        message = "Error: " + this.$refs.num_mins.errorBucket[0]
      } else {
        message = ""
      }
      this.$emit('showError', message)
    },
    displayNumWorkersError (val) {
      let message
      if (val) {
        message = "Error: " + this.$refs.num_workers.errorBucket[0]
      } else {
        message = ""
      }
      this.$emit('showError', message)
    }
  }
}
</script>